import { TrickData } from "../models/trick.model";

export const shadowTricksData: TrickData[] = [
    {
        id: 1,
        title: "Dino",
        desc: "Get your rawr on!",
        imgLoc: "/assets/images/dino-img.png",
        overlayLoc: "/assets/images/dino.png",
        alt: "dinosaur emoji",
    },
    {
        id: 2,
        title: "Dog",
        desc: "Shadows and fur!",
        imgLoc: "/assets/images/dog-img.png",
        overlayLoc: "/assets/images/dog.png",
        alt: "dog emoji",
    },
    {
        id: 3,
        title: "Croc",
        desc: "Gator town!",
        imgLoc: "/assets/images/croc-img.png",
        overlayLoc: "/assets/images/croc.png",
        alt: "croc emoji",
    },
]
